import * as yup from 'yup';
import { t } from 'i18next';
import { StaticValues } from '@utils/enums/StaticValues.enum';
import {
  MarketingConsentField,
  MarketingConsentFieldType,
} from './MarketingConsentForm.interface';

export const marketingConsentFormSchema = (fields: MarketingConsentField[]) => {
  const requiredError = t('fieldsLabel.errors.isRequired');
  const storeShape = fields.reduce<Record<string, yup.BooleanSchema>>(
    (acc, field) => {
      const shouldRequire =
        field.type === MarketingConsentFieldType.CONSENT &&
        field.config.status === StaticValues.FIELD_STATUS_MANDATORY;

      if (shouldRequire) {
        acc[field.valueKey] = yup
          .boolean()
          .oneOf([true], requiredError)
          .required(requiredError);
      }

      return acc;
    },
    {},
  );

  return yup.object().shape({
    contactsDetails: yup.object().shape({
      storeCustomFieldsMarketing: yup.object().shape(storeShape),
    }),
  });
};
